<template>
  <form class="side_box" :style="style" @submit.prevent="stopEditing">
    <div>
      <label for="ref">REF</label>
      <span v-if="this.details.ref">{{this.details.ref}}</span>
      <span v-else>  /  </span>
    </div>

    <div>
      <label for="type">Type</label>
      <span v-if="this.details.type">{{this.details.type}}</span>
      <span v-else>  /  </span>
    </div>

    <div v-if="!isEditing && this.details.type != 'assembly'">
      <label for="Comments">Raw Material</label>
      <span v-if="this.details.rawMaterialName">{{this.details.rawMaterialName}}</span>
      <span v-else>  /  </span>
    </div>
    <div v-if="isEditing && this.details.type != 'assembly'">
      <InputAutocomplete    
        label="Raw Material"
        name="RawMaterials"
        searchUrl="management/rawmaterials/"
        :isTextArea="false"
        placeholder="Raw Material"
        :isDisabled="false"
        :value="rawMat.name"
        :key="1"
        :hasLessTop="true"
        @selectedItem="gotSelectedRawMat"
      />
    </div>

    <div v-if="!isEditing">
      <label for="Comments">Production Flow</label>
      <span v-if="this.details.flowname">{{this.details.flowname}}</span>
      <span v-else>  /  </span>
    </div>
    <div v-if="isEditing" class="desc">
      <InputAutocomplete  
        label="Production Flow"
        name="ProductionFlow"
        searchUrl="management/productionFlow/"
        :isTextArea="false"
        placeholder="Production Flow"
        :isDisabled="false"
        :value="flow.name"
        :key="2"
        :hasLessTop="true"
        @selectedItem="gotSelectedFlow"
      />
    </div>

    <div v-if="!isEditing">
      <label for="Comments">Description</label>
      <span v-if="this.details.description">{{this.details.description}}</span>
      <span v-else>  /  </span>
    </div>
    <div v-if="isEditing">
      <label class="desc" for="Comments">Description</label>
      <input v-model="description" autocomplete="off"/>
    </div>

    <div v-if="!isEditing && this.userDetails.isAdmin == 1" class="icon submit" @click="startEditing">
      <BaseIcon name="pen" class="icon" />
    </div>
    <button v-if="isEditing" class="no-btn icon submit" type="submit">
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";
import InputAutocomplete from "@/components/base/InputAutocomplete";

export default {
  components: {
    BaseIcon, 
    InputDash,
    InputAutocomplete,
  },
  computed: {
    style() {
      return 'height: ' + this.height + '%';
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    details: Object
  },
  data() {
    return{
      isEditing: false,
      deviceID: '',
      flow : {id: '', name: ''},
      rawMat: {id: '', name: ''},
      description: '',
      type: '',
      ref: ''
    }
  },
  watch:{
    details: {
      handler: function() {
        this.isEditing = false
      },
    }
  },
  mounted() {
   this.setSelectedData()
  },
  methods: {
    setSelectedData(){
      this.clearData()

      this.deviceID = this.details.deviceID
      this.flow = {id: this.details.flowID, name: this.details.flowname}
      this.rawMat = {id: this.details.rawMaterialID, name: this.details.rawMaterialName}
      this.ref = this.details.ref
      this.type = this.details.type
      this.description = this.details.description
    },
    clearData() {
      this.deviceID = ""
      this.flow = {id: '', name: ''}
      this.rawMat = {id: '', name: ''}
      this.ref = ""
      this.type = ""
      this.description = ""
    },
    startEditing() {
      this.isEditing = true
    },
    putUser() {
      var url, params
      var that = this

      switch(this.type) {
        case "single":
          url = this.$endpoint + 'management/devices/part'
          params = {
            "bonPartID": this.deviceID,
            "ref": this.ref,
            "rawMaterialID": parseInt(this.rawMat.id),
            "description": this.description,
            "flowID": this.flow.id,
            "typeBonID": "1",
            "image": '',
            "imageEdit": 'false',
            "inspection": this.details.inspection,
            "IPC": this.details.ipc
          }
          break;
        case "subpart":
          url = this.$endpoint + 'management/devices/part'
          params = {
            "bonPartID": this.deviceID,
            "ref": this.ref,
            "rawMaterialID": parseInt(this.rawMat.id),
            "description": this.description,
            "flowID": this.flow.id,
            "typeBonID": "2",
            "image": '',
            "imageEdit": 'false',
            "inspection": this.details.inspection,
            "IPC": this.details.ipc
          }
          break;
        case "assembly":
          url = this.$endpoint + 'management/devices/assembly'
          params = {
            "assemblyID": this.deviceID,
            "flowID": this.flow.id,
            "ref": this.ref,
            "description": this.description,
            "image": this.details.image,
            "imageEdit": 'false',
            "inspection": this.details.inspection,
            "IPC": this.details.ipc
          }
          break;
      }

      this.$http.put(url, params)
      .then(function (response) {
        that.$emit('refresh', true);
        that.$swal(
          'Device updated!',
          `Your device has been successfully updated.`,
          'success'
        );
      })
      .catch(function (error) {
        that.$swal(
          'Oops that went wrong?',
          `Please contact the admin with the following info: ${ error }`,
          'error'
        );
      });
    },
    gotSelectedFlow(receivedItem){
      this.flow = receivedItem
    },
    gotSelectedRawMat(receivedItem){
      this.rawMat = receivedItem
    },
    stopEditing() {
      this.isEditing = false
      this.putUser()
    },
  },
  watch: {
    details: {
      handler: function() {
        this.isEditing = false
        this.setSelectedData()
      },
    }
  }
};
</script>

<style lang="scss" scoped>  
@import "@/style/base";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.side_box {
  max-height: 690px;
  
  label {
    height: 20px;

    &.desc {
      margin-top: 16px;
    }
  }

  div.desc {
    margin-top: 16px;
  }

  input, span{
    height: 30px;
    margin-bottom: 15px;
  }
}
</style>